import RequestsPage from './RequestsPage';

export default RequestsPage;
